import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GtwElementsBaseUrlsModel } from '../../../../app/shared/_models/gtw-elements-base-urls.model';
import { SourcingProjectTaggingService } from './sourcing-project-tagging.service';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';
import {
  findAppkitItemByValue,
  getAppkitDropdownSelection,
  setDropdownAriaLabel
} from '../../../shared/utils/appkit-dropdown.util';

@Component({
    selector: 'gtw-sourcing-project-tagging',
    templateUrl: './sourcing-project-tagging.component.html',
    styleUrls: ['./sourcing-project-tagging.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SourcingProjectTaggingComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);



	baseGlobalParams: any;
	baseURLs: GtwElementsBaseUrlsModel = { 'admin': '', 'api': '/gtw', "custom": '', 'efile': '', 'pdfEngine': '', 'bulkPdfEngine': '' };
	private baseURL = '/custom';
	private baseURLGtw = '/gtw';
	private checkLockedObj: any = [];
	private taggingParamObj: any = [];
	private taxYear: number = 0;
	private scenario: number = 0;
	private jcdKey: number = 0;
	private ssoId: number = 0;
	basket_id_value: any;
	ProjectTagAmt: any;
	rows: any = [];
	tableData = false;
	isModalLoading = false;
	autoRunDataLoad = false;
	tableLoadingData = false;
	FirstDiv = true;
	TwoDiv = false;
	basket_object: any = {};
	amt_exceed_obj: any = {};
	minimise = false;


	@Output('open-sourcing-project-tagging-info')
	openSourcingTagInfo = new EventEmitter<string>();

	@Output('save-sourcing-project-tagging-info')
	saveSourcingTagInfo = new EventEmitter<string>();

	@Output('close-modal')
	closeModalEvent = new EventEmitter<string>();

	@Output('request-grid-update')
	requestGridUpdate = new EventEmitter<string>();

	subscriptions: Subscription = new Subscription();




	constructor(
    private SourcingProjectTaggingService: SourcingProjectTaggingService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) { }

	SavedData: any = [];
	basketIdList: any = [];
	projectIdList: any = [];
	selectedBasketid: any = [];
	selectedProjectid: any = [];
	durationInSeconds = 5;
	CheckBasketFlag = false;
	tempGroupData: any = {};
	isResetBasketFlag = false;
	isResetProjectFlag = false;
	invalid_flag = true;
	isViewOnly: boolean = false;
	total_amt_exceed = false;
	private dataLoaded = false;



	checkInputType(): boolean {
		const t = this.taggingParamObj;
		const filingGroup = t?.FILING_GROUP ?? t?.filing_group ?? t?.FILING_KEY ?? t?.filing_key;
		const hasCombo =
			(t?.COMBINATION_KEY != null && t.COMBINATION_KEY !== '') ||
			(t?.combination_key != null && t.combination_key !== '') ||
			(t?.HO_COMBINATION_KEY != null && t.HO_COMBINATION_KEY !== '') ||
			(t?.ho_combination_key != null && t.ho_combination_key !== '');
		if (Number.isInteger(parseInt(this.taxYear + "")) &&
			Number.isInteger(parseInt(this.scenario + '')) &&
			Number.isInteger(parseInt(this.jcdKey + '')) &&
			Number.isInteger(parseInt(this.ssoId + '')) &&
			t && typeof t === 'object' &&
			filingGroup != null && filingGroup !== '' &&
			hasCombo &&
			this.checkLockedObj
		) {
			return true;
		}

		return false;
	}


	ngOnInit(): void {
    this.applyWorkspaceContext();
    this.tryInit();
    this.subscriptions.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subscriptions.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
	}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const fp = normalizeFilterParams(activeScreen);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.checkLockedObj = this.baseGlobalParams?.checkLockedbj || this.checkLockedObj;
    this.taxYear = Number(fp?.tax_year ?? this.baseGlobalParams?.tax_year ?? this.taxYear ?? 0);
    this.scenario = Number(fp?.scenario ?? this.baseGlobalParams?.scenario ?? this.scenario ?? 0);
    this.jcdKey = Number(fp?.jcd_key ?? this.baseGlobalParams?.jcd_key ?? this.jcdKey ?? 0);
    const sso = this.gtwApp?.USER_SETTINGS?.user?.sso_id;
    const n = Number(sso);
    this.ssoId = Number.isFinite(n) && !Number.isNaN(n) ? n : this.ssoId;
    this.rebuildTaggingParamObj(activeScreen, fp);
  }

  /** Merge filter params + grid row (modal open context) into API tagging payload. */
  private rebuildTaggingParamObj(activeScreen: any, fp: any): void {
    const raw = rowPayloadFromActiveScreen(activeScreen);
    const rowObj = Array.isArray(raw) ? (raw[0]?.data ?? raw[0]) : extractObject(raw);
    const g = extractObject(this.baseGlobalParams);
    const base = { ...extractObject(fp), ...extractObject(rowObj) };
    const pick = (...keys: string[]) => {
      for (const k of keys) {
        const v = base[k];
        if (v !== undefined && v !== null && v !== '') {
          return v;
        }
      }
      return undefined;
    };
    this.taggingParamObj = {
      ...base,
      FILING_GROUP: pick('FILING_GROUP', 'filing_group', 'FILING_KEY', 'filing_key') ?? g.filing_key ?? g.FILING_KEY,
      HO_COMBINATION_KEY: pick('HO_COMBINATION_KEY', 'ho_combination_key'),
      COMBINATION_KEY: pick('COMBINATION_KEY', 'combination_key'),
      TP_KEY: pick('TP_KEY', 'tp_key'),
      LOCAL_ACCT_KEY: pick('LOCAL_ACCT_KEY', 'local_acct_key', 'ACCT_KEY', 'acct_key'),
      CHART_KEY: pick('CHART_KEY', 'chart_key'),
    };
  }

	init() {
		this.getBaksetIdData();
	}

  private tryInit(): void {
    if (this.dataLoaded) {
      return;
    }
    this.init();
  }


	modalClose() {
		this.openSourcingTagInfo.emit('open-sourcing-project-tagging-info');
		this.closeModalEvent.emit('cancel');
	}


	getBaksetIdData() {
		if(!this.isModalLoading) {
			this.isModalLoading = true;
		this.basketIdList = [];
		console.log('[SourcingProjectTagging] getBaksetIdData params:', {
			taxYear: this.taxYear, scenario: this.scenario, jcdKey: this.jcdKey,
			FILING_GROUP: this.taggingParamObj?.FILING_GROUP,
			HO_COMBINATION_KEY: this.taggingParamObj?.HO_COMBINATION_KEY,
			COMBINATION_KEY: this.taggingParamObj?.COMBINATION_KEY,
			LOCAL_ACCT_KEY: this.taggingParamObj?.LOCAL_ACCT_KEY,
			TP_KEY: this.taggingParamObj?.TP_KEY,
		});
		this.SourcingProjectTaggingService.getBaksetIdData(this.baseURLs.api, this.taxYear, this.scenario, this.jcdKey, this.taggingParamObj).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			if (data) {
				let tempIssueId: any = [];
				data.forEach((value: any, i: any) => {
					let tempChannel = {
						value: value.BASKET_ID,
						index: i,
						label: value.BASKET_NAME,
						selected: false,
						total_amt: value.BASKET_AMT
					}
					tempIssueId.push(tempChannel);
				});
				this.basketIdList = tempIssueId;
				this.dataLoaded = true;
				console.log(this.basketIdList);
			}
		}, error => {
			console.log(error);
		});

		this.projectIdList = [];
		this.SourcingProjectTaggingService.getProjectIdData(this.baseURLs.api, this.taxYear, this.scenario).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			if (data) {
				let tempProjectId: any = [];
				data.forEach((value: any, i: any) => {
					let tempChannel = {
						value: value.PROJECT_ID,
						index: i,
						label: value.PROJECT_NAME,
						selected: false
					}
					tempProjectId.push(tempChannel);
				});
				this.projectIdList = tempProjectId;
				this.dataLoaded = true;
				if (this.checkInputType()) {
					this.getModalSaveData();
				} else {
					this.isModalLoading = false;
				}
				console.log(this.projectIdList);
			} else {
				this.isModalLoading = false;
			}
		}, error => {
			this.isModalLoading = false;
			console.log(error);
		});

		}
	}

	// getProjectIdData() {
	// 	this.projectIdList = [{ data: [] }];
	// 	this.SourcingProjectTaggingService.getProjectIdData(this.baseURLs.api, this.taxYear, this.scenario).subscribe((data: any) => {
	// 		if (data) {
	// 			let tempProjectId: any = [];
	// 			data.forEach((value: any, i: any) => {
	// 				let tempChannel = {
	// 					value: value.PROJECT_ID,
	// 					index: i,
	// 					text: value.PROJECT_NAME,
	// 					selected: false
	// 				}
	// 				tempProjectId.push(tempChannel);
	// 			});
	// 			this.projectIdList[0].data = tempProjectId;
	// 			this.getModalSaveData();
	// 			console.log(this.projectIdList);
	// 		}
	// 	}, error => {
	// 		console.log(error);
	// 	});


	// }



	getModalSaveData() {
		if (this.SavedData.length == 0 && !this.autoRunDataLoad) {
			this.autoRunDataLoad = true;
			this.SourcingProjectTaggingService.getSourceTaggingModalData(this.baseURLs.api, this.taxYear, this.scenario, this.jcdKey, this.taggingParamObj).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
				if (data.length > 0) {
					this.autoRunDataLoad = false;
					this.tableLoadingData = true;
					this.tableData = true;
					console.log(data);
					this.SavedData = data;
				} else {
					this.tableLoadingData = true;
					this.tableData = false;
					this.SavedData = [];
				}
			},
				error => {
					this.isModalLoading = false;
					this.autoRunDataLoad = false;
					console.log(error);
				}, () => {
					this.isModalLoading = false;
					this.autoRunDataLoad = false;
					console.log('Completed loading');
				});
		}
	}



	addRow() {
		this.TwoDiv = true;
		const row = {
			index: this.rows.length + 1,
			SELECTEDBASKETID: '',
			SELECTEDPROJECTID: '',
			PROJECT_AMT: '',
			basketList: _.cloneDeep(this.basketIdList),
			projectList: _.cloneDeep(this.projectIdList),
			selectedBasketItem: null,
			selectedProjectItem: null,
			HO_COMBINATION_KEY: this.taggingParamObj.HO_COMBINATION_KEY,
			COMBINATION_KEY: this.taggingParamObj.COMBINATION_KEY,
			TP_KEY: this.taggingParamObj.TP_KEY,
			LOCAL_ACCT_KEY: this.taggingParamObj.LOCAL_ACCT_KEY,
			CHART_KEY: this.taggingParamObj.CHART_KEY,
		};
		this.rows.push(row);
	}

	setDropdownAriaLabel(item: any, contextLabel: string = 'Option'): string {
		return setDropdownAriaLabel(item, contextLabel);
	}

	onRowBasketSelect(event: any, row: any): void {
		const selected = getAppkitDropdownSelection(event);
		row.selectedBasketItem = selected;
		row.SELECTEDBASKETID = selected?.value ?? '';
	}

	onRowProjectSelect(event: any, row: any): void {
		const selected = getAppkitDropdownSelection(event);
		row.selectedProjectItem = selected;
		row.SELECTEDPROJECTID = selected?.value ?? '';
	}

	onRowBasketSelectItem(event: any, row: any): void {
		const selected = getAppkitDropdownSelection(event);
		if (selected) {
			row.selectedBasketItem = selected;
		}
	}

	onRowProjectSelectItem(event: any, row: any): void {
		const selected = getAppkitDropdownSelection(event);
		if (selected) {
			row.selectedProjectItem = selected;
		}
	}

	private syncRowDropdownSelections(row: any): void {
		row.selectedBasketItem = findAppkitItemByValue(row.basketList, row.SELECTEDBASKETID);
		row.selectedProjectItem = findAppkitItemByValue(row.projectList, row.SELECTEDPROJECTID);
	}
	onClick() {
		this.FirstDiv = !this.FirstDiv;
	}

	deleteRow(index: any) {
		this.rows.splice(index, 1);
		if (this.rows.length > 0) {
			this.TwoDiv = true;
		}
		else {
			this.TwoDiv = false;
		}
	}

	saveData() {
		console.log(this.rows);

		let saveObject = _.cloneDeep(this.rows)
		if (saveObject.length > 0) {
			for (let i = 0; i < saveObject.length; i++) {
				delete saveObject[i].basketList;
				delete saveObject[i].projectList;
				delete saveObject[i].index;
			}
		}
		if (this.SavedData.length > 0) {
			this.SavedData.forEach((dataValue: any, i: any) => {
				saveObject.push(dataValue)
			});
		}

		for (let i = 0; i < saveObject.length; i++) {
			this.invalid_flag = false;
			if ( (saveObject[i].SELECTEDBASKETID === '' || saveObject[i].SELECTEDBASKETID === null || saveObject[i].SELECTEDBASKETID === undefined)
					|| (saveObject[i].SELECTEDPROJECTID === '' || saveObject[i].SELECTEDPROJECTID === null || saveObject[i].SELECTEDPROJECTID === undefined)
					|| (saveObject[i].PROJECT_AMT === '' || saveObject[i].PROJECT_AMT === null || saveObject[i].PROJECT_AMT === undefined)  
			){
				this.invalid_flag = true;
				break;
			}
			else {
				this.invalid_flag = false;
				
			}

		}
		if (this.invalid_flag) {
			this.SourcingProjectTaggingService.openSnackBar('Basket / Project Tag / Amount are required field', 'gtw-snackbar--red');
			return;
		}

		/* let basket_validation = _.mapValues(_.groupBy(saveObject, 'SELECTEDBASKETID'),clist => clist.map(car => _.omit(car, 'SELECTEDBASKETID')));
		let total_value : number;		
		this.basketIdList.forEach((basket: any, i: any) => {
			total_value = 0;
			if (basket_validation[basket.value]!== undefined)
			{
				basket_validation[basket.value].forEach((basket_group: any, i: any)=> {	
					total_value += basket_group.PROJECT_AMT;
					
				});
				this.basket_object[basket.value] = total_value 

			}	
				
			
			//this.basket_object[basket.value] = total_value 
		});
		
		console.log(this.basket_object);

		for (let i = 0; i < this.basketIdList.length; i++) {
			this.total_amt_exceed = false;
			if (this.basket_object[this.basketIdList[i].value] > this.basketIdList[i].total_amt){
				this.total_amt_exceed = true;
				this.amt_exceed_obj = this.basketIdList[i];
				break;
			}else {
				this.total_amt_exceed = false;
				
			}

		}

		if (this.total_amt_exceed) {
			this.SourcingProjectTaggingService.openSnackBar('Project Tag Amount for ' + ''+ '('+ this.amt_exceed_obj.label + '' +')'+ ' basket cannot be greater than  ' +  '' + '' + this.amt_exceed_obj.total_amt, 'gtw-snackbar--red');
			return;
		}
 */
		console.log(saveObject);
		let updateSubscription = this.SourcingProjectTaggingService.saveSourcingTaggingData(this.baseURLs.api, saveObject, this.taxYear, this.scenario, this.jcdKey, this.ssoId, this.baseGlobalParams, this.taggingParamObj, this.checkLockedObj).subscribe(
			(data) => {
				if (data.callSuccess == "1") {
					this.SourcingProjectTaggingService.openSnackBar('Data Saved Successfully', 'gtw-snackbar--green');
					this.saveSourcingTagInfo.emit('save-sourcing-project-tagging-info');
					this.requestGridUpdate.emit('refresh');
				} else {
					this.SourcingProjectTaggingService.openSnackBar('Error Saving Data. ' + data.errorMessage, 'gtw-snackbar--red');
				}
			}, error => { this.SourcingProjectTaggingService.openSnackBar('Save failed. ' + error.error.errorMessage, 'gtw-snackbar--red'); },
			() => { console.log("Update Completed"); }
		);
		this.subscriptions.add(updateSubscription);

	}

}
